module.exports = __webpack_public_path__ + "img/qualifications-pc.3e2ff24e.png";